import { useQuery } from "@tanstack/react-query";

import { QueryKeys } from "@/api/core";
import { useAuth } from "@/contexts/auth/useAuth";
import { useApi } from "@/hooks";

interface IPolicy {
  pending_policy_id: string;
}

function usePendingPolicy() {
  const api = useApi();
  const { currentAccount } = useAuth();

  const getPolicy = async () => {
    const { data } = await api.get<IPolicy>("/api/v1/truth/policies/pending");

    return data;
  };

  return useQuery({
    queryKey: QueryKeys.policies.global,
    queryFn: getPolicy,
    retry: 3,
    refetchOnWindowFocus: true,
    staleTime: 60000, // 1 minute
    cacheTime: Infinity,
    enabled: !!currentAccount,
  });
}

export { usePendingPolicy };
